import { render } from "./tiptap.vue?vue&type=template&id=376f456c"
import script from "./tiptap.vue?vue&type=script&lang=js"
export * from "./tiptap.vue?vue&type=script&lang=js"

import "./tiptap.vue?vue&type=style&index=0&id=376f456c&lang=scss"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__